import {
  DueOut,
  DueOutFetchArgs,
  getDueOuts,
} from '../../assets/ts/data/dueout/dueout'
import useServerData from '../use-server-data'

function useDueouts(fetchArgs, waitOnParentDependency = false) {
  const {
    data: dueouts,
    error: dueoutsError,
    fetchData: fetchDueout,
    isLoading: dueoutsAreLoading,
  } = useServerData<DueOut, DueOutFetchArgs>(
    getDueOuts,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    dueouts,
    dueoutsAreLoading,
    dueoutsError,
    fetchDueout,
    refetch: fetchDueout, // For re-fetching
  }
}

export default useDueouts
